import React from 'react';
import DesktopPrimaryRail from './DesktopPrimaryRail';
import DesktopSecondaryRail from './DesktopSecondaryRail';

/**
 * DesktopRailNavigation - Main component that combines DesktopPrimaryRail and DesktopSecondaryRail
 * Provides two-row navigation for desktop NFL dashboard
 * Adapted from mobile RailNavigation for desktop interface
 *
 * @param {string} sport - Current sport context
 * @param {Array} primaryTabs - Tabs for primary rail
 * @param {Array} filters - Filter configuration for secondary rail
 * @param {Function} onFilterChange - Callback when any filter changes
 * @param {Function} onTabChange - Callback when primary tab changes
 * @param {string} activeTab - Currently active tab
 * @param {Function} onReset - Callback to reset all filters
 * @param {boolean} hasActiveFilters - Whether any filters are active (non-default)
 * @param {string} className - Additional CSS classes
 * @param {ReactNode} children - Optional child components
 */
const DesktopRailNavigation = ({
  sport,
  primaryTabs = [],
  filters = [],
  onFilterChange,
  onTabChange,
  activeTab,
  onReset,
  hasActiveFilters = false,
  className = '',
  children
}) => {
  return (
    <div
      className={`
        bg-black/5 backdrop-blur-sm rounded-lg overflow-hidden
        ${className}
      `}
      role="navigation"
      aria-label="Filter navigation"
    >
      {/* Primary Rail - Sport/League Tabs */}
      <DesktopPrimaryRail
        tabs={primaryTabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
        variant={sport === 'all' ? 'sport' : 'league'}
      />

      {/* Secondary Rail - Filter Chips */}
      <DesktopSecondaryRail
        filters={filters}
        onFilterChange={onFilterChange}
        onReset={onReset}
        hasActiveFilters={hasActiveFilters}
      />

      {/* Optional slot for custom components */}
      {children && (
        <div className="px-4 py-3 bg-black/10 border-t border-white/10">
          {children}
        </div>
      )}
    </div>
  );
};

// Export sub-components for flexibility
DesktopRailNavigation.PrimaryRail = DesktopPrimaryRail;
DesktopRailNavigation.SecondaryRail = DesktopSecondaryRail;

export default DesktopRailNavigation;
